export const fontSizes = { extraLarge: '76px', large: '60px', medium: '48px', small: '36px' };
export const colors = { black: '#29000b', brown: '#7c2828', green: '#029602', yellow: '#fdea22' };
export const fontFamilies = {
  semiBold: 'WixMadeforDisplaySemiBold',
  bold: 'WixMadeforDisplayBold',
  extraBold: 'WixMadeforDisplayExtraBold',
};
